import React, {Component} from 'react';
import {API_URL} from "../../../settings/local_settings";
import {APIClient} from "../../../utils/APIClient";
import {DashboardTodayCell} from "./cells/DashboardTodayCell";
import {DashboardFullPeriodBudgetProportionalCell} from "./cells/with_bars/DashboardFullPeriodBudgetProportionalCell";
import {DashboardFullPeriodODSCell} from "./cells/single_value/DashboardFullPeriodODSCell";
import {DashboardFullPeriodODSVsSomethingCell} from "./cells/value_vs_expected/DashboardFullPeriodODSVsSomethingCell";
import {DashboardFullPeriodConversionsCell} from "./cells/with_bars/DashboardFullPeriodConversionsCell";
import {
    CURRENT_PERIOD_CPA_VS_COLUMNS,
    FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN,
    FULL_PERIOD_COST_VS_PROJECTED_COLUMN,
    FULL_PERIOD_CONVERSIONS_COLUMN,
    CURRENT_PERIOD_CPA_COLUMN,
    FULL_PERIOD_ODS_COLUMN,
    FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN,
    INDICATORS_COLUMNS,
    LABELS_COLUMN,
    LAST_PERIOD_BUDGET_DATA,
    CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN,
    CURRENT_PERIOD_PERIOD_DATES_COLUMN,
    CURRENT_PERIOD_BUDGET_DATA,
    TODAY_COLUMNS,
    YESTERDAY_CPA_VS_COLUMNS,
    YESTERDAY_EXPENSES_COLUMN,
    PURCHASES_VALUE_COLUMN,
    LAST_PERIOD_PURCHASES_VALUE_COLUMN,
    ROAS_COLUMN,
    ACOS_COLUMN,
    FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN,
    FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN,
    ONLY_FOR_BU_NOT_BUCC_COLUMN,
    CURRENCY_COLUMN,
    CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN,
    CURRENT_PERIOD_TIME_COMPLETION_COLUMN,
    CURRENT_PERIOD_COST_VS_TIME_COLUMN,
    AVAILABLE_FUNDS_COLUMN,
    COMMENTS_COLUMN,
    PLATFORM_BUDGET_COLUMN,
    CAMPAIGN_STATUS_COLUMN,
    DAYS_TILL_FUNDS_ARE_OUT_COLUMN,
    AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN,
    LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN,
    FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN,
    FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN,
    GOAL_1_COLUMN,
    GOAL_2_COLUMN,
    FLEX_INDICATOR_COLUMN_TO_DATA,
    getPeriodsData,
    CAMPAIGN_AND_ADGROUP_ROW_EXCLUDED_COLUMNS,
    NO_COMPARATION_PERIOD, GOAL_1_INFO_COLUMN, GOAL_2_INFO_COLUMN,
    getColumnHeaderInformation
} from "../columns";
import {ChannelsHelper} from "../../channels/channels";
import {DashboardFullPeriodYesterdayCell} from "./cells/single_value/DashboardFullPeriodYesterdayCell";
import {DashboardLabelsCell} from "./cells/DashboardLabelsCell";
import {BusinessUnitNameCell} from "./BusinessUnitNameCell";
import {DashboardSingleValueCell} from "./cells/base/DashboardSingleValueCell";
import {LIVE_META_REASON_GA4_NOT_ADDITIVE} from "./cells/base/DashboardCell";
import {DashboardBudgetCell} from "./cells/DashboardBudgetCell";
import {DashboardYesterdayCPAVsPeriodCell} from "./cells/value_vs_expected/DashboardYesterdayCPAVsPeriodCell";
import {DashboardCurrentCPAVsPeriodCell} from "./cells/value_vs_expected/DashboardCurrentCPAVsPeriodCell";
import {WebSocketChannels, WebSocketEvents} from "../../../websockets/WebSocketsClient";
import {isRecalculating} from "../../alerts_center/shared/recalculation";
import {WebSocketEvent} from "../../../websockets/WebSocketEvent";
import {CellWithErrorHandler} from "./cells/CellWithErrorHandler";
import {
    DashboardFullPeriodROASVsLastPeriodCell
} from "./cells/value_vs_expected/DashboardFullPeriodROASVsLastPeriodCell - copia";
import {DashboardFullPeriodACOSVsLastPeriodCell} from "./cells/value_vs_expected/DashboardFullPeriodACOSVsLastPeriodCell";
import {BusinessUnitAdAccountNameCell} from "./BusinessUnitAdAccountNameCell";
import {DashboardCurrencyCell} from "./cells/DashboardCurrencyCell";
import {EmptyCell} from "./cells/base/EmptyCell";
import {DashboardAvailableFundsCell} from "./cells/DashboardAvailableFundsCell";
import {DashboardValueWithAlertCell} from "./cells/DashboardValueWithAlertCell";
import {DashboardGoalBarsCell} from "./cells/with_bars/DashboardGoalBarsCell";
import {DashboardValueVsExpectedCell} from "./cells/base/DashboardValueVsExpectedCell";
import {CampaignNameCell} from "./CampaignNameCell";
import {AdgroupNameCell} from "./AdgroupNameCell";
import {UnidentifiedNameCell} from "./UnidentifiedNameCell";
import {PlatformBudgetCell} from "./cells/PlatformBudgetCell";
import {CampaignStatusBadgeCell} from "./cells/CampaignStatusBadgeCell";
import {CAMPAIGN_STATUS_ACTIVE, ADGROUP_STATUS_ACTIVE} from "../../../marketing";
import {TYPE_ONE_BUDGET_PER_CAMPAIGN, TYPE_ONE_BUDGET_PER_ADGROUP} from "../../business_units/BusinessUnitTypes";
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import {DashboardCommentsCell} from "./cells/DashboardCommentsCell";
import {DashboardCurrentCostVsTimeCell} from "./cells/value_vs_expected/DashboardCurrentCostVsTimeCell";
import {SyncingCell} from "./cells/base/SyncingCell";
import {DashboardPeriodDatesCell} from "./cells/DashboardPeriodDatesCell";
import {DashboardGoalGoalCell} from "./cells/DashboardGoalGoalCell";
import {ItemPeriodDates} from "../../../utils/ItemPeriodDates";
import {DatetimeHelper} from "../../../utils/DatetimeHelper";
import {BoardSyncNotice} from "./BoardSyncNotice";

export const TYPE_BUSINESS_UNIT = 'TYPE_BUSINESS_UNIT';
export const TYPE_CAMPAIGNS_CONFIGURATION = 'TYPE_CAMPAIGNS_CONFIGURATION';
export const TYPE_CAMPAIGN = 'TYPE_CAMPAIGN';
export const TYPE_ADGROUP = 'TYPE_ADGROUP';
// «Sin identificar»: el GA4 de una campaña abierta que no coincide con ninguno de sus grupos. No es
// un grupo: no tiene presupuesto, objetivo, comentarios ni fechas, y sólo muestra las columnas GA4.
export const TYPE_UNIDENTIFIED = 'TYPE_UNIDENTIFIED';

// Hasta este ancho la columna fija del nombre ocupa casi toda la vista: el aviso de una línea que no se
// actualiza no entra a su lado y va en una fila propia, debajo (QA-VIS-rp-fe-61 y -81).
export const NARROW_NOTICE_QUERY = '(max-width: 767.98px)';

// Cada cuánto se vuelve a preguntar si la línea terminó de recalcularse, si el WebSocket no avisó.
export const RECALCULATION_RECHECK_MS = 20 * 1000;

function narrowNoticeMedia() {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(NARROW_NOTICE_QUERY) : null;
}

export class DashboardRowClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            businessUnitNeverSynced: false,
            businessUnitNotStarted: false,
            businessUnitWithoutCampaignsConfiguration: false,
            // El fetch de métricas de ESTA línea falló. Es un estado de la fila, no un cartel:
            // hay una fila por Línea de Control y todas piden en paralelo, así que un `alert()`
            // acá se multiplica por la cantidad de líneas y —al ser modal nativo— congela el
            // render de las que SÍ respondieron bien. Es lo que reportó Angie (Bakián) el
            // 2026-09-14: "no puedo ver las Líneas de Control", Aceptar, "cargan algunas y
            // otras quedan en gris". Las grises eran las que fallaron, cada una con su cartel.
            businessUnitDataError: null,
            downUrlsCount: this.props.downUrlsCount,
            hasUrls: this.props.hasUrls,
            syncInformation: this.props.syncInformation,
            showOldDataLayer: this.props.syncInformation && this.props.syncInformation.has_sync_problems_for_a_long_time,
            showingAdAccountsRows: false,
            loadingNotActiveCampaignsOrAdgroupByBuccId: {},
            detailsColumnData: null,
            // Portal del Cliente: lista de cuentas (BUCCs) traída on-demand al expandir.
            // En la agencia esto llega por la prop `adAccountsData`.
            clientAdAccountsData: null,
            showOnlyActiveCampaignsOrAdgroupsByBuccId: {},
            showingAdgroupsRowsByCampaignId: {},
            narrowNotice: !!(narrowNoticeMedia() && narrowNoticeMedia().matches),
        };

        this._adAccountsRowsBeginExpanded = null;
        // this._campaignsRowsBeingExpanded = {}; // Por adAccountId

        this.handleURLStatusChange = this.handleURLStatusChange.bind(this);
        this.handleSnoozeAllAlerts = this.handleSnoozeAllAlerts.bind(this);
        this.handleStopSnoozeForAllAlerts = this.handleStopSnoozeForAllAlerts.bind(this);
        this.handleWebSocketDataUpdateRequest = this.handleWebSocketDataUpdateRequest.bind(this);
        this.handleBusinessUnitSync = this.handleBusinessUnitSync.bind(this);
        this.handleBudgetUpdated = this.handleBudgetUpdated.bind(this);
        this.handlePeriodDatesUpdated = this.handlePeriodDatesUpdated.bind(this);
        this.handleGoalUpdated = this.handleGoalUpdated.bind(this);
        this.handleAvailableFundsUpdated = this.handleAvailableFundsUpdated.bind(this);
        this.handleCommentsUpdated = this.handleCommentsUpdated.bind(this);
        this.handleToggleAdAccountsRows = this.handleToggleAdAccountsRows.bind(this);
        this.fetchClientAdAccountsData = this.fetchClientAdAccountsData.bind(this);
        this.handleOnlyActiveCampaignsOrAdgroupsChanged = this.handleOnlyActiveCampaignsOrAdgroupsChanged.bind(this);
        this.handleToggleAdgroupsRows = this.handleToggleAdgroupsRows.bind(this);
        this.handleRetryBusinessUnitData = this.handleRetryBusinessUnitData.bind(this);
        this.getBusinessUnitData = this.getBusinessUnitData.bind(this);
        this.handleGa4AttributionSaved = this.handleGa4AttributionSaved.bind(this);
        this.handleNarrowNoticeChange = this.handleNarrowNoticeChange.bind(this);
    }

    // getFromLocalStorage() {
    //     const showingCampaignRowsByBuccId = {};
    //     this.props.adAccountsData.forEach((data) => {
    //         const buccId_str = data.id.toString();
    //         const value = localStorage.getItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}-${buccId_str}`);
    //         showingCampaignRowsByBuccId[buccId_str] = value !== null ? value === "true" : false;
    //     });
    //     return showingCampaignRowsByBuccId;
    // }

    componentDidMount() {
        this.getBusinessUnitData();
        // Una línea que ya venía recalculándose (se recargó el Tablero en el medio) también se sigue.
        this._followRecalculation(this.props.syncInformation);
        //this.fetchBusinessUnitSyncStatus();
        // this.fetchBusinessUnitAlert();

        if (this._getBusinessUnitIsExpanded()) {
            this.handleToggleAdAccountsRows();
        }

        this._narrowNoticeMedia = narrowNoticeMedia();
        if (this._narrowNoticeMedia && this._narrowNoticeMedia.addEventListener) {
            this._narrowNoticeMedia.addEventListener('change', this.handleNarrowNoticeChange);
        }
    }

    componentWillUnmount() {
        if (this._narrowNoticeMedia && this._narrowNoticeMedia.removeEventListener) {
            this._narrowNoticeMedia.removeEventListener('change', this.handleNarrowNoticeChange);
        }
        clearTimeout(this._recalculationTimer);
        this._unmounted = true;
    }

    handleNarrowNoticeChange(event) {
        this.setState({narrowNotice: !!event.matches});
    }

    // API calls

    getBusinessUnitData() {
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/dashboard/metrics`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({businessUnitDataError: null});
                    this.props.onBusinessDataFetched(this.props.businessUnitId, response.data);
                } else if (response.status === 'ERROR_SYNC_PENDING') {
                    this.setState({businessUnitNeverSynced: true, businessUnitDataError: null});
                } else if (response.status === 'ERROR_BU_EVENTUAL_NOT_STARTED') {
                    this.setState({businessUnitNotStarted: true, businessUnitDataError: null});
                } else if (response.status === 'ERROR_NO_CAMPAIGNS_OR_ADGROUPS') {
                    this.setState({businessUnitWithoutCampaignsConfiguration: true, businessUnitDataError: null});
                } else {
                    // El error queda EN la fila. `error_message` puede venir vacío (un 500 sin
                    // JSON cae al genérico del APIClient), por eso el render tiene su propio
                    // texto y esto es sólo el detalle cuando el backend lo mandó tipado.
                    this.setState({businessUnitDataError: response.error_message || ''});
                }
            });
    }

    handleRetryBusinessUnitData() {
        this.setState({businessUnitDataError: null}, this.getBusinessUnitData);
    }

    // Refrescos de FONDO: los dispara un evento de WebSocket, no un gesto del usuario. Si fallan,
    // la fila conserva el contador de URLs caídas / el estado de sync que ya tenía; interrumpir
    // con un cartel a alguien que no pidió nada es peor que quedarse con el dato anterior. El 5xx
    // lo reporta `APIClient` a Sentry, así que dejar de avisar acá no lo vuelve invisible.
    refreshAlertInfo() {
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/down-urls`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        downUrlsCount: response.down_urls_count,
                        hasUrls: response.has_urls,
                    });
                }
            })
            // El silencio es deliberado, y el `.catch()` explícito lo documenta: `APIClient.call()`
            // ya absorbe el fallo de red, pero un throw DENTRO del `.then` (un `setState` sobre una
            // fila que un filtro acaba de desmontar) quedaría como unhandled rejection sin dueño.
            .catch(() => {});
    }

    // `refreshCellsWhenRecalculated`: si esta lectura ve que el recálculo terminó, vuelve a pedir las celdas. El
    // WebSocket ya las pide por su cuenta, así que él lo apaga.
    fetchBusinessUnitSyncStatus({refreshCellsWhenRecalculated = true} = {}) {
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/sync-information`).call('GET')
            .then((response) => {
                if (this._unmounted) return;
                if (response.status !== 'OK') {
                    // Un pedido caído no corta el respaldo: se sigue preguntando mientras la marca esté vigente.
                    this._followRecalculation(this.state.syncInformation);
                    return;
                }
                const wasRecalculating = isRecalculating(this.state.syncInformation);
                this.setState({
                    syncInformation: response.data
                });
                if (refreshCellsWhenRecalculated && wasRecalculating && !isRecalculating(response.data)) {
                    this._refreshCells();
                }
                this._followRecalculation(response.data);
            });
    }

    // Mientras la línea se recalcula por un cambio guardado (card Fnvibexi), el ícono gira. Lo apaga el aviso del
    // WebSocket cuando el recálculo termina (`handleWebSocketDataUpdateRequest`); si ese aviso no llega (la cuota
    // de Pusher), se vuelve a preguntar cada `RECALCULATION_RECHECK_MS`, y la lectura que ve el final vuelve a pedir
    // las celdas. `isRecalculating` corta a los 10 minutos de la marca, como el backend: no queda preguntando para
    // siempre. Con la pestaña oculta no pregunta: espera al próximo turno (review C-03).
    _followRecalculation(syncInformation) {
        clearTimeout(this._recalculationTimer);
        if (!isRecalculating(syncInformation)) return;
        this._recalculationTimer = setTimeout(() => {
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
                this._followRecalculation(this.state.syncInformation);
                return;
            }
            this.fetchBusinessUnitSyncStatus();
        }, RECALCULATION_RECHECK_MS);
    }

    // Lo mismo que pide el aviso del WebSocket cuando la línea se sincronizó.
    _refreshCells() {
        if (this.state.detailsColumnData !== null)
            this.fetchDetailsColumnData(this.getBusinessUnitData);
        else
            this.getBusinessUnitData();
    }

    // fetchBusinessUnitAlert() {
    //     const url = API_URL + `business-unit/${this.props.businessUnitId}/alerts`;
    //     new APIClient(url).call('GET')
    //         .then((response) => {
    //             if (response.status === 'OK') {
    //                 this.setState({
    //                     generalAlerts: response.data
    //                 });
    //             } else {
    //                 alert(response.error_message);
    //             }
    //         });
    // }

    fetchDetailsColumnData(callbackFunction) {
        const { t } = this.props;
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/dashboard/campaigns_configuration/info/`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        detailsColumnData: response.data,
                    }, callbackFunction);
                } else {
                    // Acá SÍ hubo un gesto del usuario (desplegó la línea) y no va a pasar nada:
                    // toast, que avisa sin bloquear ni frenar a las demás filas.
                    toast.error(t('dashboard_row.error_occurred_contact_team'));
                }
            })
            .catch(() => {
                toast.error(t('dashboard_row.error_occurred_contact_team'));
            });
    }

    fetchClientAdAccountsData() {
        // Portal del Cliente: la lista de cuentas (BUCCs) no viene por prop. La traemos
        // de `campaigns-configurations` (dict keyed por BUCC id) y derivamos el shape que
        // espera `_renderBusinessUnitAdAccountRow` (id/channel/account_id/name). Las
        // métricas de cada sub-fila salen de `detailsColumnData` matcheando por ese id.
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/campaigns-configurations`).call('GET')
            .then((response) => {
                if (response.status === 'OK' && response.data) {
                    const clientAdAccountsData = Object.entries(response.data).map(([buccId, bucc]) => ({
                        id: bucc.id !== undefined ? bucc.id : parseInt(buccId, 10),
                        channel: bucc.channel,
                        account_id: bucc.platform_account_id !== undefined ? bucc.platform_account_id : bucc.ad_account_id,
                        name: bucc.name,
                        // Estados por cuenta: si el endpoint los trae, viajan tal cual a la celda
                        // (el portal los muestra como información, sin CTA de reconexión).
                        account_status: bucc.account_status,
                    }));
                    this.setState({clientAdAccountsData: clientAdAccountsData});
                }
            });
    }

    fetchCampaignsAndAdgroupsNotActiveData(buccId) {
        const { t } = this.props;
        const newLoadingNotActiveCampaignsOrAdgroupsByBuccId = this.state.loadingNotActiveCampaignsOrAdgroupByBuccId;
        newLoadingNotActiveCampaignsOrAdgroupsByBuccId[buccId] = true;

        this.setState({
            loadingNotActiveCampaignsOrAdgroupsByBuccId: newLoadingNotActiveCampaignsOrAdgroupsByBuccId
        });

        const url = API_URL + `campaigns-configurations/${buccId}/campaigns-and-adgroups-not-active/dashboard/info/`;
        new APIClient(url).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    const itemsData = response.data;

                    // Se actualiza el item del bucc
                    const newDetailsColumnDataForBucc = this._getDetailsColumnDataForBusinessUnitAdAccount(buccId)
                    newDetailsColumnDataForBucc["notActiveItemsLoaded"] = true;
                    newDetailsColumnDataForBucc.campaigns_data = newDetailsColumnDataForBucc.campaigns_data.concat(itemsData["campaigns_data"]);
                    newDetailsColumnDataForBucc.adgroups_data = newDetailsColumnDataForBucc.adgroups_data.concat(itemsData["adgroups_data"]);

                    // Se mete en la lista el item actualizado pisando el viejo
                    const newDetailsColumnData = this.updateDetailsForBuccId(buccId, newDetailsColumnDataForBucc);

                    const newLoadingNotActiveCampaignsOrAdgroupByBuccId = this.state.loadingNotActiveCampaignsOrAdgroupByBuccId;
                    newLoadingNotActiveCampaignsOrAdgroupByBuccId[buccId] = false;

                    this.setState({
                        detailsColumnData: newDetailsColumnData,
                        // FEDE: aca va newLoa... o loadin...? antes estaba newLo.. pero parece un bug
                        newLoadingNotActiveCampaignsOrAdgroupByBuccId: newLoadingNotActiveCampaignsOrAdgroupByBuccId
                    });
                } else {
                    this._stopLoadingNotActiveFor(buccId);
                    toast.error(t('dashboard_row.error_occurred_contact_team'));
                }
            })
            .catch(() => {
                this._stopLoadingNotActiveFor(buccId);
                toast.error(t('dashboard_row.error_occurred_contact_team'));
            });
    }

    /**
     * El flag de "cargando" se prende ANTES del request y hasta ahora sólo se apagaba en el camino
     * feliz: si el fetch fallaba, el spinner de esa cuenta giraba para siempre (además del cartel).
     * Se apaga en los dos caminos de error.
     */
    _stopLoadingNotActiveFor(buccId) {
        const loadingByBuccId = this.state.loadingNotActiveCampaignsOrAdgroupByBuccId;
        loadingByBuccId[buccId] = false;
        this.setState({loadingNotActiveCampaignsOrAdgroupByBuccId: loadingByBuccId});
    }

    updateDetailsForBuccId(buccId, newDetailsColumnDataForBucc) {
        return this.state.detailsColumnData.map((item) => {
            if(item.id !== buccId)
                return item;
            else {
                return newDetailsColumnDataForBucc;
            }
        });
    }

    // handlers

    // handleToggleCampaignsRows(buccId) {
    //     const showingCampaignRowsByBuccId = this.state.showingCampaignRowsByBuccId;
    //     const buccId_str = buccId.toString();
    //
    //     if(!showingCampaignRowsByBuccId.hasOwnProperty(buccId_str)) {
    //         showingCampaignRowsByBuccId[buccId_str] = false;
    //     }
    //
    //     // Cambia el valor
    //     showingCampaignRowsByBuccId[buccId_str]= !showingCampaignRowsByBuccId[buccId_str];
    //
    //     // Si se quiere ver el detalle y no lo tengo, lo traigo
    //     if (showingCampaignRowsByBuccId[buccId_str] && this.state.detailsColumnData === null) {
    //         this.fetchDetailsColumnData();
    //     }
    //
    //     this._setAdAccountIsExpanded(showingCampaignRowsByBuccId[buccId_str], buccId);
    //     this.setState({showingCampaignRowsByBuccId: showingCampaignRowsByBuccId});
    // }

    handleToggleAdAccountsRows() {
        const newValue = !this.state.showingAdAccountsRows

        // Si se quiere ver el detalle (métricas por cuenta/campaña/adgroup) y no lo tengo,
        // lo traigo.
        if (newValue && this.state.detailsColumnData === null) {
            this.fetchDetailsColumnData();
        }

        // Portal del Cliente: además del detalle, traemos la lista de cuentas (BUCCs) para
        // poder renderizar las sub-filas (en la agencia llega por la prop adAccountsData).
        if (newValue && this.props.loadClientAdAccounts && this.state.clientAdAccountsData === null) {
            this.fetchClientAdAccountsData();
        }

        this._setBusinessUnitIsExpanded(newValue);
        this.setState({showingAdAccountsRows: newValue});
    }

    handleToggleAdgroupsRows(campaignId) {
        const showingAdgroupsRowsByCampaignId = this.state.showingAdgroupsRowsByCampaignId;
        if (showingAdgroupsRowsByCampaignId[campaignId] === undefined)
            showingAdgroupsRowsByCampaignId[campaignId] = false

        showingAdgroupsRowsByCampaignId[campaignId] = !showingAdgroupsRowsByCampaignId[campaignId];

        this.setState({showingAdgroupsRowsByCampaignId: showingAdgroupsRowsByCampaignId});
    }

    syncBusinessUnitURL() {
        return `${API_URL}business-unit/${this.props.businessUnitId}/sync-manually`
    }

    handleBusinessUnitSync() {
        if (!this.state.syncInformation.is_on_sync && !this.state.syncInformation.is_being_synced_on_demand) {
            const syncBusinessUnitRequest = new APIClient(this.syncBusinessUnitURL()).call('POST');
            syncBusinessUnitRequest.then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        syncInformation: {
                            ...this.state.syncAlert,
                            is_being_synced_on_demand: true,
                        }
                    })
                }
            });
        }
    }

    handleURLStatusChange(message) {
        if (message.businessUnitId === this.props.businessUnitId) {
            this.refreshAlertInfo();
        }
    }

    // La regla de cruce con GA4 de una cuenta se guardó desde el cartel de una celda: la fila se vuelve
    // a pedir entera, como cuando el WebSocket avisa una sincronización. Si no, el cartel seguía
    // invitando a configurar hasta recargar (C-tablero-frontend-02).
    handleGa4AttributionSaved() {
        this.fetchDetailsColumnData(this.getBusinessUnitData);
    }

    handleWebSocketDataUpdateRequest(message) {
        if (message.businessUnitId === this.props.businessUnitId) {
            this._refreshCells();
            this.fetchBusinessUnitSyncStatus({refreshCellsWhenRecalculated: false});
            // this.fetchBusinessUnitAlert();
        }
    }

    // handlers - snooze all alerts

    handleSnoozeAllAlerts(snoozeData) {
        // `snoozeData` = `{period, snoozed_until}` de la respuesta del backend, para que la fila diga
        // "hasta cuándo" sin recargar el tablero.
        this.props.onSnoozeAllAlerts(this.props.businessUnitId, snoozeData);
    }

    handleStopSnoozeForAllAlerts() {
        this.props.onStopSnoozeForAllAlerts(this.props.businessUnitId);
    }

    handleCommentsUpdated(campaignId, adgroupId, rowsData) {
        this._updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData);
    }

    handleBudgetUpdated(campaignId, adgroupId, rowsData) {
        this._updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData);
        // Guardar el presupuesto deja la línea «recalculando»: el ícono lo dice ya, no recién con el WebSocket.
        this.fetchBusinessUnitSyncStatus();
    }

    handlePeriodDatesUpdated(campaignId, adgroupId, rowsData) {
        this._updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData);
    }

    getNewCampaignDataForBuccId(detailsForBucc, campaignId, dashboard) {
        return (detailsForBucc.campaigns_data ?? []).map(campaign_data => {
            if (campaign_data.id !== campaignId)
                return campaign_data;
            dashboard.adgroups_data = campaign_data.adgroups_data;
            // La respuesta de editar la campaña (presupuesto, objetivo…) trae su fila sin los grupos
            // ni «Sin identificar»: se conservan los que ya estaban, o la fila desaparece al guardar.
            if (dashboard.unidentified_data === undefined)
                dashboard.unidentified_data = campaign_data.unidentified_data;
            return dashboard;
        });
    }

    getCampaignDataOfAdgroupId(detailsForBucc, adgroupId) {
        let theCampaignData = null;
        detailsForBucc.campaigns_data.forEach(campaignData => {
            campaignData.adgroups_data.forEach(adgroupData => {
                if(adgroupId === adgroupData.id) {
                    theCampaignData = campaignData;
                }
            });
        });

        return theCampaignData;
    }

    getNewAdgroupDataForBuccId(detailsForBucc, adgroupId, dashboard, adgroups_data) {
        return adgroups_data.map(adgroup_data => {
            if (adgroup_data.id !== adgroupId)
                return adgroup_data;
            else
                return dashboard;
        });
    }

    handleGoalUpdated(campaignId, adgroupId, rowsData) {
        this._updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData);
    }

    _updateDetailsDataAndBusinessUnitData(campaignId, adgroupId, rowsData) {
        if (campaignId > 0 || adgroupId > 0) {
            // Se actualizo un objetivo. No cambia el bucc pero lo actualizamos igual porque adentor esta la campaña y facilita
            const buccRow = rowsData['campaigns_configuration'];
            const buccRowDashboard = buccRow["dashboard"];
            const buccId = parseInt(buccRow["id"], 10);
            const originalBuccDetailsData = this._getDetailsColumnDataForBusinessUnitAdAccount(buccId)

            if(campaignId > 0) {
                const campaignRow = rowsData['campaign'];
                const campaignRowDashboard = campaignRow["dashboard"];
                buccRowDashboard.campaigns_data = this.getNewCampaignDataForBuccId(originalBuccDetailsData, parseInt(campaignRowDashboard["id"], 10), campaignRowDashboard);
            } else if(adgroupId > 0) {
                const adgroupRow = rowsData['adgroup'];
                const adgroupRowDashboard = adgroupRow["dashboard"];

                // Si se está mostrando adgroups sin campaigns:
                if((originalBuccDetailsData.adgroups_data?.length ?? 0) > 0) {
                    buccRowDashboard.adgroups_data = this.getNewAdgroupDataForBuccId(originalBuccDetailsData, parseInt(adgroupRowDashboard["id"], 10), adgroupRowDashboard, originalBuccDetailsData.adgroups_data);
                } else {
                    const campaign_data = this.getCampaignDataOfAdgroupId(originalBuccDetailsData, adgroupId);
                    if (campaign_data) {
                        campaign_data.adgroups_data =  this.getNewAdgroupDataForBuccId(originalBuccDetailsData, parseInt(adgroupRowDashboard["id"], 10), adgroupRowDashboard, campaign_data.adgroups_data);
                        buccRowDashboard.campaigns_data = this.getNewCampaignDataForBuccId(originalBuccDetailsData, parseInt(campaign_data["id"], 10), campaign_data);
                    }
                }

            }
            const newDetailsData = this.updateDetailsForBuccId(buccId, buccRowDashboard);
            this.setState({
                detailsColumnData: newDetailsData
            });
        }

        this.props.onBusinessDataFetched(this.props.businessUnitId, rowsData["business_unit"]["dashboard"]);
    }

    handleAvailableFundsUpdated(businessUnitData) {
        this.props.onBusinessDataFetched(this.props.businessUnitId, businessUnitData);
    }

    handleOnlyActiveCampaignsOrAdgroupsChanged(buccId, showOnlyActive) {
        const newShowOnlyActiveCampaignsOrAdgroupsByBuccId =  this.state.showOnlyActiveCampaignsOrAdgroupsByBuccId;
        newShowOnlyActiveCampaignsOrAdgroupsByBuccId[buccId] = showOnlyActive;

        if(showOnlyActive !== true) {
            // Si nunca se trayeron las pausadas, las mando a cargar
            const detailsDataForBucc = this._getDetailsColumnDataForBusinessUnitAdAccount(buccId);
            if(detailsDataForBucc === null || detailsDataForBucc === undefined)
                return;

            const itemsLoaded = detailsDataForBucc["notActiveItemsLoaded"] === true;
            if (!itemsLoaded)
                this.fetchCampaignsAndAdgroupsNotActiveData(buccId);
        }

        this.setState({
            showOnlyActiveCampaignsOrAdgroupsByBuccId: newShowOnlyActiveCampaignsOrAdgroupsByBuccId
        });
    }

    // aux

    _rowCampaignClassName() {
        const className = this._rowClassName();
        return `campaign-row ${className}`
    }

    _rowAdgroupClassName() {
        const className = this._rowClassName();
        return `adgroup-row ${className}`
    }

    _rowClassName() {
        const isOddRow = this.props.rowOrderNumber % 2 === 1;
        const oddClass = isOddRow ? 'odd' : '';
        
        if (this._hasDownUrls()) {
            return `${oddClass} bu-alert false`.trim();
        }
        
        return oddClass;
    }

    _hasDownUrls() {
        return this.state.downUrlsCount > 0;
    }

    _numberOfColumns() {
        return this.props.activeColumns.length;
    }

    _businessUnitIsSnoozed() {
        // `alerts_snooze` (fila de `dashboard/basic-data`) es el silencio VIVO de la línea: "todas
        // las alertas silenciadas" y hasta cuándo. Si el backend todavía no lo manda (deploys
        // separados), se cae a la deducción vieja por el flag persistido del primer indicador.
        if (this.props.alertsSnooze) {
            return this.props.alertsSnooze.is_snoozed;
        }
        if (this.props.businessUnitData !== null) {
            const anIndicatorData = this.props.businessUnitData[INDICATORS_COLUMNS[0]];
            // Se creo un presupuesto nuevo y anIndicatorData era undefined falló. Por eso se pone un parche acá
            // hasta que se reprodusca/solucione bien
            return anIndicatorData !== undefined ? anIndicatorData.alert_snoozed : false;
        }
        // Ni el silencio vivo ni las columnas: todavía no se sabe. `null` (y no `false`) es lo que
        // hace que la campanita muestre su estado de carga en vez de afirmar que no está silenciada.
        return null;
    }

    _setBusinessUnitIsExpanded(value) {
        // FEDE: 2023-11: Deshabilitamos esto para que no le exigamos mucho al server-front. Que el usuario expanda la que quiere
        // localStorage.setItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}`, value);
    }

    _setAdAccountIsExpanded(value, buccId) {
        // FEDE: 2023-11: Deshabilitamos esto para que no le exigamos mucho al server-front. Que el usuario expanda la que quiere
        // localStorage.setItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}-${buccId}`, value);
    }

    _getBusinessUnitIsExpanded() {
        if (this._adAccountsRowsBeginExpanded === null) {
            const value = localStorage.getItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}`);
            this._adAccountsRowsBeginExpanded = value !== null ? value === "true" : false;
        }
        return this._adAccountsRowsBeginExpanded;
    }

    // _getAdAccountIsExpanded(buccId) {
    //     const buccId_str = buccId.toString();
    //     if (!this.state.showingCampaignRowsByBuccId.hasOwnProperty(buccId_str)) {
    //         const value = localStorage.getItem(`BusinessUnitIsExpanded-${this.props.businessUnitId}-${buccId}`);
    //         this._campaignsRowsBeingExpanded[buccId_str] = value !== null ? value === "true" : false;
    //     }
    //     return this._campaignsRowsBeingExpanded[buccId_str];
    // }

    // render

    _renderCellsForActiveColumns(data, rowType, campaignsConfigurationId, campaignId, adgroupId) {
        if (data !== null) {

            if(rowType === TYPE_BUSINESS_UNIT && this._shouldRenderVeryOldDataLayer()) {
                return this._renderBusinessUnitWithVeryOldData();
            }

            const cols = this.props.activeColumns.map((columnId, index) => {
                return this._renderCellFor(columnId, data[columnId], index, rowType, campaignsConfigurationId, campaignId, adgroupId)
            });
            return cols;
        } else if (this.state.businessUnitNeverSynced) {
            return this._renderBusinessUnitNotSynced();
        } else if (this.state.businessUnitNotStarted) {
            return this._renderBusinessUnitNotStarted();
        } else if (this.state.businessUnitWithoutCampaignsConfiguration) {
            return this._renderBusinessUnitWithoutCampaignsConfiguration();
        } else if (this.state.businessUnitDataError !== null && rowType === TYPE_BUSINESS_UNIT) {
            // Va DESPUÉS de los estados de negocio (nunca sincronizada / sin empezar / sin
            // campañas) y ANTES del loader: sin esto la fila que falló se queda girando para
            // siempre, que es la parte "queda en gris" del reporte.
            //
            // Sólo en la fila de la LÍNEA. Este método lo comparten las sub-filas de cuenta,
            // campaña y grupo, y el fetch que falló es uno solo: con la línea desplegada —que
            // puede venir abierta, el expandido se recuerda en `localStorage`— cada sub-fila
            // repetía el mismo mensaje con su propio «Reintentar», N links disparando el mismo
            // refetch. Abajo siguen con el loader, que es lo que los hermanos ya hacían.
            return this._renderBusinessUnitDataError();
        } else {
            return this._renderLoader();
        }
    }

    _shouldRenderVeryOldDataLayer() {
        return this.state.syncInformation && this.state.syncInformation.has_sync_problems_for_a_long_time && this.state.showOldDataLayer;
    }

    _renderCellFor(columnName, columnData, key, rowType, campaignsConfigurationId, campaignId, adgroupId) {
        const { t } = this.props;
        const columnHeaderInfo = getColumnHeaderInformation(t);
        // viewMode='client' (Portal del Cliente): celdas de solo lectura. Reusamos las
        // MISMAS celdas que el Tablero general (mismos niveles/sensibilidad del backend);
        // sólo cambia el estilo vía CSS scopeado y se ocultan las acciones de edición.
        const isClientView = (this.props.viewMode || 'agency') === 'client';
        let cell = null;

        // Va PRIMERO: la fila «Sin identificar» no puede caer en ninguna celda editable (presupuesto,
        // objetivo, comentarios, fechas), que se guardaría contra un grupo que no existe, ni en el
        // «sincronizando» de una columna sin dato, que acá no espera nada: el backend manda `null` en
        // todo lo que no es GA4. Tampoco el ⓘ de dato vacío, que habla de campañas y grupos.
        if (rowType === TYPE_UNIDENTIFIED && !this._unidentifiedRowShows(columnName, columnData))
            cell = <EmptyCell/>;
        else if (rowType === TYPE_CAMPAIGNS_CONFIGURATION && ONLY_FOR_BU_NOT_BUCC_COLUMN.includes(columnName))
            cell = <EmptyCell/>;
        else if ((rowType === TYPE_CAMPAIGN || rowType === TYPE_ADGROUP) && CAMPAIGN_AND_ADGROUP_ROW_EXCLUDED_COLUMNS.includes(columnName))
            cell = <EmptyCell/>;
        // La columna está en la vista pero el payload NO la trae: el Tablero sirve lo que dejó el
        // último sync de esa línea, así que una columna AGREGADA después no existe en su caché hasta
        // que esa línea vuelva a sincronizar. Casi todas las celdas desreferencian `data.algo` sin
        // guarda, así que sin esto la fila entera muere con «Detalles del error» — lo vio el QA al
        // estrenar «Costo ideal vs. Presupuesto en plataforma» (QA-VIS-colA-01), y es el defecto que
        // va a repetir CADA columna nueva. La guarda va acá y no en una celda porque el modo de
        // fallo es de todas: los cuatro hermanos ODS comparten la misma celda, y sus vecinas el
        // mismo patrón. `SyncingCell` es además lo que el caso significa —el dato viene cuando esa
        // línea sincronice— y es el mismo tratamiento que las columnas de HOY ya le daban.
        else if (columnData === undefined || columnData === null)
            cell = <SyncingCell/>;
        else if (TODAY_COLUMNS.includes(columnName)) {
            if(!columnData){
                cell = <SyncingCell />
            }
            else if (columnData.ordering_values !== undefined && columnData.formatted_value === undefined) {
                // Para BUCC de Analytics, las columnas de HOY vienen vacías con solo ordering_values y status
                cell = <EmptyCell />
            }
            else {
                cell = <DashboardTodayCell key={key} metricName={columnHeaderInfo[columnName]['title']}
                                           data={columnData}
                                           businessUnitId={this.props.businessUnitId}/>
            }
        } else if (columnName === DAYS_TILL_FUNDS_ARE_OUT_COLUMN) {
            cell = <DashboardValueWithAlertCell key={key} metricName={columnHeaderInfo[columnName]['title']}
                                                data={columnData}/>
        } else if (CURRENT_PERIOD_CPA_VS_COLUMNS.includes(columnName)) {
            cell = <DashboardCurrentCPAVsPeriodCell key={key} data={columnData} businessUnitId={this.props.businessUnitId}/>
        } else if (YESTERDAY_CPA_VS_COLUMNS.includes(columnName)) {
            cell = <DashboardYesterdayCPAVsPeriodCell key={key} data={columnData} businessUnitId={this.props.businessUnitId}/>
        } else if (columnName === CURRENT_PERIOD_COST_VS_TIME_COLUMN) {
            cell = <DashboardCurrentCostVsTimeCell key={key} data={columnData}/>
        } else if (columnName === FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN || columnName === FULL_PERIOD_COST_VS_PROJECTED_COLUMN) {
            // Misma celda — el backend ya devuelve el dict con las mismas keys; solo cambia el % de desvío.
            cell = <DashboardFullPeriodBudgetProportionalCell key={key} data={columnData}
                                                              rowType={rowType}
                                                              businessUnitId={this.props.businessUnitId}
                                                              />
        } else if (columnName === FULL_PERIOD_ODS_COLUMN) {
            cell = <DashboardFullPeriodODSCell key={key} data={columnData} businessUnitId={this.props.businessUnitId}/>
        } else if (columnName === YESTERDAY_EXPENSES_COLUMN || columnName === LAST_7_DAYS_AVERAGE_EXPENSES_COLUMN) {
            cell = <DashboardFullPeriodYesterdayCell key={key} data={columnData} rowType={rowType}/>
        } else if (columnName === FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN ||
            columnName === FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN ||
            columnName === FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN
        ) {
            cell = <DashboardFullPeriodODSVsSomethingCell key={key} data={columnData} businessUnitId={this.props.businessUnitId}/>
        } else if (columnName === FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN) {
            cell = <DashboardFullPeriodROASVsLastPeriodCell key={key} data={columnData} rowType={rowType}/>
        } else if (columnName === FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN) {
            cell = <DashboardFullPeriodACOSVsLastPeriodCell key={key} data={columnData} rowType={rowType}/>
        } else if (columnName === FULL_PERIOD_CONVERSIONS_COLUMN) {
            cell = <DashboardFullPeriodConversionsCell key={key} data={columnData} rowType={rowType} businessUnitId={this.props.businessUnitId}/>
        } else if (columnName === CURRENT_PERIOD_ALLOCATED_BUDGET_COLUMN) {
            cell = <DashboardBudgetCell key={key}
                                        formattedValue={columnData.formatted_value}
                                        value={columnData.value}
                                        status={columnData.status}
                                        budgetPartialGoals={columnData.partial_goals}
                                        budgetPartialGoalsInputDefinition={columnData.partial_goals_input_definition}
                                        periodType={columnData.period_type_enum}
                                        fromDate={DatetimeHelper.formatDateFromString(columnData.from_date)}
                                        toDate={DatetimeHelper.formatDateFromString(columnData.to_date)}
                                        businessUnitId={this.props.businessUnitId}
                                        campaignsConfigurationId={campaignsConfigurationId}
                                        campaignId={campaignId}
                                        adgroupId={adgroupId}
                                        clientName={this.props.clientName}
                                        businessUnitName={this.props.businessUnitName}
                                        budgetType={this.props.budgetType}
                                        onBudgetUpdated={this.handleBudgetUpdated}
                                        budgetIsNotSet={columnData.budget_is_not_set}
                                        informativeCampaignsBudgetSum={columnData.informative_campaigns_budget_sum}
                                        businessUnitCurrency={this.props.businessUnitCurrency}
                                        rowType={rowType}
                                        readOnly={isClientView}
            />;
        } else if (columnName === CURRENT_PERIOD_PERIOD_DATES_COLUMN) {
            // Para que luego del deploy no se rompan los presupuesto que todavia no sincronizaron.
            if(!columnData)
                cell = <EmptyCell />;
            else {
                const data = {
                    "from_date": DatetimeHelper.formatDateFromString(columnData.from_date),
                    "to_date": DatetimeHelper.formatDateFromString(columnData.to_date),
                    "period_type": columnData.period_type_enum,
                    "item_schedule_configuration": columnData.item_schedule_configuration
                };

                const itemPeriodDates = new ItemPeriodDates(data);
                cell = <DashboardPeriodDatesCell key={key}
                                                 status={columnData.status}
                                                 clientName={this.props.clientName}
                                                 businessUnitId={this.props.businessUnitId}
                                                 businessUnitName={this.props.businessUnitName}
                                                 campaignsConfigurationId={campaignsConfigurationId}
                                                 campaignId={campaignId}
                                                 adgroupId={adgroupId}
                                                 rowType={rowType}
                                                 itemPeriodDates={itemPeriodDates}
                                                 onPeriodDatesUpdated={this.handlePeriodDatesUpdated}
                                                 readOnly={isClientView}
                />;
            }
        } else if (columnName === AVAILABLE_FUNDS_COLUMN) {
            cell = <DashboardAvailableFundsCell key={key}
                                                status={columnData.status}
                                                formattedValue={columnData.formatted_value}
                                                value={columnData.value}
                                                businessUnitId={this.props.businessUnitId}
                                                onAvailableFundsUpdated={this.handleAvailableFundsUpdated}
                                                rowType={rowType}
                                                readOnly={isClientView}
            />;
        } else if (columnName === COMMENTS_COLUMN) {
            cell = <DashboardCommentsCell key={key}
                                          formattedValue={columnData.formatted_value}
                                          value={columnData.value}
                                          status={columnData.status}
                                          businessUnitId={this.props.businessUnitId}
                                          campaignsConfigurationId={campaignsConfigurationId}
                                          campaignId={campaignId}
                                          adgroupId={adgroupId}
                                          onCommentsUpdated={this.handleCommentsUpdated}
                                          rowType={rowType}
                                          readOnly={isClientView}
            />;
        } else if (columnName === PLATFORM_BUDGET_COLUMN) {
            cell = <PlatformBudgetCell key={key} platformBudget={columnData ? columnData.value : null} rowType={rowType} />;
        } else if (columnName === CAMPAIGN_STATUS_COLUMN) {
            cell = <CampaignStatusBadgeCell key={key} status={columnData ? columnData.value : null}
                                           reason={columnData ? columnData.delivery_reason : null}
                                           reasonParams={columnData ? columnData.delivery_reason_params : null}
                                           rowType={rowType} />;
        } else if (columnName === CURRENCY_COLUMN) {
            // La moneda de la línea puede diferir de la de sus cuentas publicitarias: en ese caso
            // los importes se muestran convertidos y hay que avisarlo (card 0juTriFx).
            cell = <DashboardCurrencyCell key={key}
                                          value={columnData ? columnData.formatted_value : null}
                                          status={columnData ? columnData.status : null}
                                          conversions={this.props.currencyConversions}
            />;
        } else if (LAST_PERIOD_BUDGET_DATA.includes(columnName) || CURRENT_PERIOD_BUDGET_DATA.includes(columnName) ||
            columnName === CURRENT_PERIOD_CPA_COLUMN || columnName === PURCHASES_VALUE_COLUMN ||
            columnName === ROAS_COLUMN || columnName === ACOS_COLUMN || columnName === LAST_PERIOD_PURCHASES_VALUE_COLUMN ||
            columnName === CURRENT_PERIOD_AMOUNT_COMPLETION_COLUMN ||
            columnName === CURRENT_PERIOD_TIME_COMPLETION_COLUMN ||
            columnName === AVAILABLE_FUNDS_LAST_UPLOAD_ON_COLUMN
        ) {
            cell = <DashboardSingleValueCell key={key} value={columnData.formatted_value} status={columnData.status} />
        } else if (columnName === LABELS_COLUMN) {
            cell = <DashboardLabelsCell key={key}
                                        data={this.props.businessUnitLabels}
                                        businessUnitId={this.props.businessUnitId}
                                        onLabelsChange={this.props.onLabelsChange}
                                        readOnly={isClientView}
            />;
        } else if (columnName === GOAL_1_COLUMN || columnName === GOAL_2_COLUMN) {
            cell = <DashboardGoalBarsCell key={key}
                                          data={columnData}
                                          rowType={rowType}
                                          businessUnitId={this.props.businessUnitId}
                                          campaignsConfigurationId={campaignsConfigurationId}
                                          campaignId={campaignId}
                                          adgroupId={adgroupId}
                                          onGoalUpdated={this.handleGoalUpdated}
                                          priority={columnHeaderInfo[columnName]["priority"]}
                                          readOnly={isClientView}
                                          t={this.props.t}
            />;
        } else if (columnName === GOAL_1_INFO_COLUMN || columnName === GOAL_2_INFO_COLUMN) {
            // Para que luego del deploy no se rompan los presupuesto que todavia no sincronizaron.
            if(!columnData)
                cell = <EmptyCell />;
            else
                cell = <DashboardGoalGoalCell key={key}
                                              data={columnData}
                                              rowType={rowType}
                                              businessUnitId={this.props.businessUnitId}
                                              campaignsConfigurationId={campaignsConfigurationId}
                                              campaignId={campaignId}
                                              adgroupId={adgroupId}
                                              onGoalUpdated={this.handleGoalUpdated}
                                              priority={columnHeaderInfo[columnName]["priority"]}
                                              readOnly={isClientView}
                />;
        } else if (this._isIndicatorColumn(columnName)) {
            const flexIndicatorData = FLEX_INDICATOR_COLUMN_TO_DATA(columnName)
            // `readOnly` y `adAccountName`: el cartel de una cuenta sin regla de cruce con GA4 ofrece
            // configurarla (nunca en el portal del cliente) y titula el modal con la cuenta.
            const adAccountName = this._adAccountNameOf(campaignsConfigurationId);
            if (columnData === undefined || columnData === null) {
                cell = <SyncingCell />
            }
            else if(flexIndicatorData["vsPeriod"] === NO_COMPARATION_PERIOD){
                cell = <DashboardSingleValueCell key={key} value={columnData.fluctuation_formatted_value}  status={columnData.status}
                    columnData={columnData}
                    metricName={flexIndicatorData["metricName"]}
                    isAdgroupRow={rowType === TYPE_ADGROUP}
                    readOnly={isClientView}
                    adAccountName={adAccountName}
                    onGa4AttributionSaved={this.handleGa4AttributionSaved}
                />
            } else {
                cell = <DashboardValueVsExpectedCell key={key}
                                                     value={columnData.fluctuation_formatted_value}
                                                     status={columnData.status}
                                                     expectedValue={columnData.fluctuation_formatted_expected_value}
                                                     metricName={flexIndicatorData["metricName"]}
                                                     mainPeriod={getPeriodsData(t)[flexIndicatorData["mainPeriod"]]}
                                                     vsPeriod={getPeriodsData(t)[flexIndicatorData["vsPeriod"]]}
                                                     vsPeriodValue={columnData.fluctuation_formatted_vs_period_value}
                                                     alertLevel={columnData.alert_level}
                                                     alertSnoozed={columnData.alert_snoozed}
                                                     fluctuation={columnData.fluctuation}
                                                     fluctuationPercentage={columnData.fluctuation_formatted_percentage}
                                                     columnData={columnData}
                                                     readOnly={isClientView}
                                                     adAccountName={adAccountName}
                                                     onGa4AttributionSaved={this.handleGa4AttributionSaved}
                />;
            }
        }

        return (
            <CellWithErrorHandler key={key}>
                {cell}
            </CellWithErrorHandler>
        );
    }

    _isIndicatorColumn(columnName) {
        const {agencyFlexIndicators, ga4Indicators, ecommerceIndicators, paidMediaIndicators, metaIndicators,
            googleIndicators, tiktokIndicators, customMetricIndicators} = this.props;
        return (agencyFlexIndicators != null && agencyFlexIndicators.includes(columnName))
            || (ga4Indicators != null && ga4Indicators.includes(columnName))
            || (ecommerceIndicators != null && ecommerceIndicators.includes(columnName))
            || (paidMediaIndicators != null && paidMediaIndicators.includes(columnName))
            || (metaIndicators != null && metaIndicators.includes(columnName))
            || (googleIndicators != null && googleIndicators.includes(columnName))
            || (tiktokIndicators != null && tiktokIndicators.includes(columnName))
            || (customMetricIndicators != null && customMetricIndicators.includes(columnName));
    }

    // Lo único que dibuja la fila «Sin identificar»: una columna de métrica con un número (también el
    // 0, que dice que todo el tráfico de la campaña cruzó), o Usuarios, que no tiene número porque no
    // se suma entre grupos y lo dice con su ⓘ, como la campaña. Sin número —la campaña no se vio en
    // GA4, o es un ratio que necesita el costo— la celda queda vacía.
    _unidentifiedRowShows(columnName, columnData) {
        if (!this._isIndicatorColumn(columnName) || columnData === undefined || columnData === null) {
            return false;
        }
        const hasNumber = columnData.main_period_value !== undefined && columnData.main_period_value !== null;
        const notAdditive = Boolean(columnData.live_meta) && columnData.live_meta.reason === LIVE_META_REASON_GA4_NOT_ADDITIVE;
        return hasNumber || notAdditive;
    }

    _adAccountsData() {
        // Agencia: las cuentas llegan por `adAccountsData`. Portal del Cliente: se traen on-demand
        // al expandir (fetchClientAdAccountsData) y quedan en state.
        return (this.props.adAccountsData && this.props.adAccountsData.length > 0)
            ? this.props.adAccountsData
            : (this.state.clientAdAccountsData || []);
    }

    _adAccountNameOf(campaignsConfigurationId) {
        if (campaignsConfigurationId === null || campaignsConfigurationId === undefined) return null;
        const adAccountData = this._adAccountsData().find((data) => data.id === campaignsConfigurationId);
        return adAccountData ? adAccountData.name : null;
    }

    _renderBusinessUnitWithoutCampaignsConfiguration() {
        const { t } = this.props;
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <p className="loader-message">{t('dashboard_row.control_line_no_accounts_or_campaigns')}</p>
            </td>
        );
    }

    /**
     * La línea no se actualiza hace mucho (M5 de la tanda «Reconexión de pauta», UD-21): con una cuenta
     * sin acceso, cuál y quién la ve, con «Reconectar»; con varias, «Reconectar» lleva a Cuentas; si no
     * es de acceso —o es el portal del cliente—, desde cuándo. En el portal las cuentas no llegan por
     * prop (se piden al desplegar), y de todos modos ahí no van nombres ni botón.
     */
    _renderBusinessUnitWithVeryOldData() {
        // En angosto el aviso va en su propia fila, debajo (`_renderBoardSyncNoticeRow`): acá la celda queda vacía.
        if (this.state.narrowNotice) {
            return <td colSpan={this._numberOfColumns()} className="row-loader board-sync-notice-slot"/>;
        }
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                {this._boardSyncNotice()}
            </td>
        );
    }

    _boardSyncNotice() {
        const isClientView = (this.props.viewMode || 'agency') === 'client';
        return <BoardSyncNotice syncInformation={this.state.syncInformation}
                                adAccountsData={isClientView ? [] : this._adAccountsData()}
                                isClientView={isClientView}
                                onShowRow={() => this.setState({showOldDataLayer: false})}/>;
    }

    /** El aviso a todo el ancho visible, debajo del nombre de la línea, cuando la pantalla es angosta. */
    _renderBoardSyncNoticeRow() {
        if (!this.state.narrowNotice || this.props.businessUnitData === null
            || this.props.businessUnitData === undefined || !this._shouldRenderVeryOldDataLayer()) {
            return null;
        }
        return (
            <tr className={`${this._rowClassName()} board-sync-notice-row`.trim()}>
                <td colSpan={this._numberOfColumns() + 1} className="row-loader">
                    {this._boardSyncNotice()}
                </td>
            </tr>
        );
    }

    _renderBusinessUnitNotSynced() {
        const { t } = this.props;
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <p className="loader-message">{t('dashboard_row.control_line_processing')}</p>
            </td>
        );
    }

    /**
     * Sin `title` con el detalle crudo: era la afordancia equivocada. El tooltip nativo no se ve en
     * mobile, no sale en el screenshot que el usuario le manda a soporte —justo cuando ese detalle
     * serviría— y la lente del repo pide `warning-tooltip`, no `title`. Además el texto que traía
     * podía ser el `detail` de DRF en inglés. El detalle del 5xx ahora viaja a Sentry con su
     * endpoint y su cuerpo, que es donde se puede usar.
     */
    _renderBusinessUnitDataError() {
        const { t } = this.props;
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <p className="loader-message">
                    {t('dashboard_row.data_error')}{' '}
                    <a href="#" onClick={(e) => { e.preventDefault(); this.handleRetryBusinessUnitData(); }}>
                        {t('dashboard_row.data_error_retry')}
                    </a>
                </p>
            </td>
        );
    }

    _renderBusinessUnitNotStarted() {
        const { t } = this.props;
        return (
            <td colSpan={this._numberOfColumns()} className="row-loader">
                <p className="loader-info-message">{t('dashboard_row.control_line_not_started')}</p>
            </td>
        );
    }


    _renderLoader(includeNameCell=false) {
        let numberOfColumns = this._numberOfColumns();
        if(includeNameCell)
            numberOfColumns += 1;

        return (
            <td colSpan={numberOfColumns} className="row-loader">
                <div className="loader"/>
            </td>
        );
    }

    _getDetailsColumnDataForBusinessUnitAdAccount(businessUnitAdAccountId) {
        const businessUnitAdAccountData = this.state.detailsColumnData !== null ? this.state.detailsColumnData.find(data => {
            return data !== null && data.id === businessUnitAdAccountId;
        }) : null;

        return businessUnitAdAccountData !== undefined ? businessUnitAdAccountData : null;
    }

    _renderCellsForActiveColumnsForBusinessUnitAdAccount(businessUnitAdAccountData) {
        const campaignsConfigurationId = businessUnitAdAccountData !== null? businessUnitAdAccountData.id : null;
        return this._renderCellsForActiveColumns(businessUnitAdAccountData, TYPE_CAMPAIGNS_CONFIGURATION, campaignsConfigurationId, null, null);
    }

    _renderBusinessUnitAdAccountsRows() {
        if (!this.state.showingAdAccountsRows)
            return;

        // Las métricas de cada sub-fila salen de `detailsColumnData` (fetch interno) matcheando por id.
        let rows = [];
        this._adAccountsData().forEach((data) => {
            const row = this._renderBusinessUnitAdAccountRow(data);
            rows.push(row);

            const campaignsRows = this._renderCampaignRows(data.id, data.channel);
            rows = rows.concat(campaignsRows);

            const adgroupsRows = this._renderAdgroupRows(data.id);
            rows = rows.concat(adgroupsRows);

            if(this.state.loadingNotActiveCampaignsOrAdgroupByBuccId[data.id] === true)
            {
                const loadingRow = this._renderLoader(true);
                rows.push(loadingRow);
            }
        });



        return rows;
    }

    _renderCampaignRows(businessUnitAdAccountId, channel) {
        // if (!this.state.showingCampaignRowsByBuccId[businessUnitAdAccountId.toString()])
        //     return;

        const businessUnitAdAccountData = this._getDetailsColumnDataForBusinessUnitAdAccount(businessUnitAdAccountId);
        if(businessUnitAdAccountData === null || businessUnitAdAccountData.campaigns_data === undefined)
            return;

        const rows = [];
        businessUnitAdAccountData.campaigns_data.forEach((campaign_data) => {

                if(campaign_data.status !== CAMPAIGN_STATUS_ACTIVE && this.state.showOnlyActiveCampaignsOrAdgroupsByBuccId[businessUnitAdAccountId] === true)
                    return;

                const row = this._renderCampaignRow(businessUnitAdAccountId, campaign_data, channel);
                rows.push(row);

        });

        return rows;
    }

    _renderCampaignRow(campaignsConfigurationId, data, channel) {
        const hasAdgroups = data.adgroups_data !== null && data.adgroups_data !== undefined && data.adgroups_data.length > 0;
        // `unidentified_data` es HERMANA de `adgroups_data` (nunca adentro: un Tablero viejo la
        // dibujaría como un grupo editable). Con ella sola la campaña ya se despliega.
        const unidentifiedData = data.unidentified_data || null;
        const showingAdgroups = this.state.showingAdgroupsRowsByCampaignId[data.id] === true;
        const newCampaignsRows =[<tr className={this._rowCampaignClassName()} data-id={"campaign".concat(data.id)}>
            <CampaignNameCell
                campaignId={data.id}
                campaignName={data.name}
                onAdgroupsDataToggle={this.handleToggleAdgroupsRows}
                status={data.status}
                hasAdgroupsData={hasAdgroups || unidentifiedData !== null}
                adgroupsShowing={showingAdgroups}
            />
            {this._renderCellsForActiveColumns(data, TYPE_CAMPAIGN, campaignsConfigurationId, data.id, null)}
        </tr>];

        // Se agregan las filas de los adgroups
        if (showingAdgroups) {
            (data.adgroups_data || []).forEach((adgroup_data) => {
                newCampaignsRows.push(this._renderAdgroupRow(campaignsConfigurationId, adgroup_data, true));
            });
            // Al final de sus grupos: es lo que les falta para sumar lo mismo que la campaña.
            if (unidentifiedData !== null) {
                newCampaignsRows.push(this._renderUnidentifiedRow(campaignsConfigurationId, data.id, unidentifiedData, channel));
            }
        }

        return newCampaignsRows;
    }

    _renderUnidentifiedRow(campaignsConfigurationId, campaignId, data, channel) {
        return <tr className={`${this._rowAdgroupClassName()} -unidentified`}
                   key={"unidentified".concat(campaignId)}
                   data-id={"unidentified".concat(campaignId)}
                   data-testid="dashboard-unidentified-row">
            <UnidentifiedNameCell t={this.props.t} channel={channel} rule={data.rule}
                                  readOnly={(this.props.viewMode || 'agency') === 'client'}/>
            {this._renderCellsForActiveColumns(data, TYPE_UNIDENTIFIED, campaignsConfigurationId, null, null)}
        </tr>;
    }

    _renderAdgroupRows(businessUnitAdAccountId) {
        // if (!this.state.showingCampaignRowsByBuccId[businessUnitAdAccountId.toString()])
        //     return;

        const businessUnitAdAccountData = this._getDetailsColumnDataForBusinessUnitAdAccount(businessUnitAdAccountId);
        if(businessUnitAdAccountData === null || businessUnitAdAccountData.adgroups_data === undefined)
            return;

        const rows = [];
        businessUnitAdAccountData.adgroups_data.forEach((adgroup_data) => {

                if(adgroup_data.status !== ADGROUP_STATUS_ACTIVE && this.state.showOnlyActiveCampaignsOrAdgroupsByBuccId[businessUnitAdAccountId] === true)
                    return;

                const row = this._renderAdgroupRow(businessUnitAdAccountId, adgroup_data, false);
                rows.push(row);

        });

        return rows;
    }

    _renderAdgroupRow(campaignsConfigurationId, data, insideCampaignRow) {
        return <tr className={this._rowAdgroupClassName()} data-id={"adgroup".concat(data.id)}>
            <AdgroupNameCell
                adgroupId={data.id}
                adgroupName={data.name}
                status={data.status}
                campaignName={data.campaign_name}
                insideCampaignRow={insideCampaignRow}
            />
            {this._renderCellsForActiveColumns(data, TYPE_ADGROUP, campaignsConfigurationId, null, data.id)}
        </tr>;
    }

    _renderBusinessUnitAdAccountRow(data) {
        const businessUnitAdAccountData = this._getDetailsColumnDataForBusinessUnitAdAccount(data.id);
        // Si el BU es a nivel campaña entonces dejo ver Pausadas
        const showNotActiveItems = (this.props.businessUnitType === TYPE_ONE_BUDGET_PER_CAMPAIGN || this.props.businessUnitType === TYPE_ONE_BUDGET_PER_ADGROUP);
        const showFilter = businessUnitAdAccountData !== null && showNotActiveItems;
        const channelHasCampaignOrAdgroupLevel = ChannelsHelper.channelHasCampaignOrAdgroupLevel(data.channel);
        const showOnlyActiveLabel = businessUnitAdAccountData !== null && !showNotActiveItems && channelHasCampaignOrAdgroupLevel;


        return <tr className={this._rowClassName()} data-id={"bucc".concat(data.id)}>
            <BusinessUnitAdAccountNameCell
                buccId={data.id}
                channel={data.channel}
                accountId={data.account_id}
                accountName={data.name}
                // onCampaignsDataToggle={() => (this.handleToggleCampaignsRows(data.id))}
                onOnlyActiveCampaignsChange={this.handleOnlyActiveCampaignsOrAdgroupsChanged}
                // campaignsRowsExpanded={this.state.showingCampaignRowsByBuccId[data.id.toString()]}
                // `account_status` es POR CUENTA (lo nuevo); `generalAlerts` es de la LÍNEA entera y
                // queda sólo como fallback de compat mientras el backend viejo esté deployado.
                accountStatus={data.account_status}
                generalAlerts={this.props.generalAlerts}
                showFilter={showFilter}
                showOnlyActiveLabel={showOnlyActiveLabel}
                accountCurrency={data.currency}
                currencyConversions={this.props.currencyConversions}
                uncoveredSpend={data.uncovered_spend}
                businessUnitId={this.props.businessUnitId}
                viewMode={this.props.viewMode}
            />
            {this._renderCellsForActiveColumnsForBusinessUnitAdAccount(businessUnitAdAccountData)}
        </tr>;
    }

    render() {
        // viewMode='client' (Portal del Cliente V2 — Tablero formato tabla):
        // - BusinessUnitNameCell esconde controles agency-only (snooze, labels, links a /client y /business-unit).
        // - Se omite suscripción a URL_STATUS_CHANGE (los clientes no monitorean URLs).
        // - Se mantiene BU_DASHBOARD_SYNCED para live updates cuando la agencia sincroniza.
        const viewMode = this.props.viewMode || 'agency';
        const isClientView = viewMode === 'client';

        return (
            <React.Fragment>
                <tr className={this._rowClassName()} data-id={this.props.businessUnitId}>
                    <BusinessUnitNameCell businessUnitId={this.props.businessUnitId}
                                          businessUnitName={this.props.businessUnitName}
                                          adAccountsData={this.props.adAccountsData}
                                          hasDownUrls={this._hasDownUrls()}
                                          downUrlsCount={this.state.downUrlsCount}
                                          hasUrls={this.state.hasUrls}
                                          channels={this.props.channels}
                                          clientId={this.props.clientId}
                                          clientName={this.props.clientName}
                                          businessUnitLabels={this.props.businessUnitLabels}
                                          onLabelsChange={this.props.onLabelsChange}
                                          isSnoozed={this._businessUnitIsSnoozed()}
                                          snoozedUntil={this.props.alertsSnooze ? this.props.alertsSnooze.snoozed_until : null}
                                          onSnoozeAllAlerts={this.handleSnoozeAllAlerts}
                                          onStopSnoozeForAllAlerts={this.handleStopSnoozeForAllAlerts}
                                          generalAlerts={this.props.generalAlerts}
                                          uncoveredSpend={this.props.uncoveredSpend}
                                          syncInformation={this.state.syncInformation}
                                          onBusinessUnitSync={this.handleBusinessUnitSync}
                                          hasAdAccountsDataToShow={this.props.hasAdAccountsDataToShow}
                                          onAdAccountsDataToggle={this.handleToggleAdAccountsRows}
                                          AdAccountsRowsExpanded={this._getBusinessUnitIsExpanded()}
                                          location={this.props.location}
                                          viewMode={viewMode}
                                          guideRow={this.props.guideRow === true}
                    />
                    {this._renderCellsForActiveColumns(this.props.businessUnitData, TYPE_BUSINESS_UNIT, null, null, null)}
                    <WebSocketEvent eventId={WebSocketEvents.BU_DASHBOARD_SYNCED}
                                    channelId={WebSocketChannels.BU_DASHBOARD_SYNC}
                                    onEventTriggered={this.handleWebSocketDataUpdateRequest}
                    />
                    {!isClientView && (
                        <WebSocketEvent eventId={WebSocketEvents.URL_STATUS_CHANGE}
                                        channelId={WebSocketChannels.URL_STATUS_CHANGE}
                                        onEventTriggered={this.handleURLStatusChange}
                        />
                    )}
                </tr>
                {this._renderBoardSyncNoticeRow()}
                {this._renderBusinessUnitAdAccountsRows()}
            </React.Fragment>
        )
    }
}

export const DashboardRow = withTranslation()(DashboardRowClass);
export default DashboardRow;
